module.exports = __webpack_public_path__ + "static/media/3-mapa-de-vida-puerto-rico1.abdc19ed.jpg";